// extracted by mini-css-extract-plugin
export default {"apportationsPercentageContainer":"propuesta-three-values-percentage-bar_apportationsPercentageContainer__yeqb5"};